import { render, staticRenderFns } from "./InterviewMagazine.vue?vue&type=template&id=0f3f3ede"
import script from "./InterviewMagazine.vue?vue&type=script&lang=js"
export * from "./InterviewMagazine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports